export function loadWealthManagementModule() {
  return import('./index');
}
